import { FC } from 'react'
import styled, { css } from 'styled-components'

const ExternalLoading: FC = () => {
  return <StyledWrapper />
}

export default ExternalLoading

const StyledWrapper = styled.div`
  @keyframes loadingAnimation {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }

  ${({ theme }) => css`
    width: 182px;
    height: 12px;
    border-radius: 6px;
    background-color: #eeeeee;
    position: relative;
    overflow: hidden;
    margin: 0 auto;

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      background-color: ${theme.color.primary_2};
      border-radius: 6px;
      animation: loadingAnimation 1s infinite ease-in-out;
      position: absolute;
      top: 0;
      left: -100%;
      will-change: left, animation;
    }
  `}
`
